import React, { Component } from 'react';


class Radio extends Component {
    render() {
        const { name, options, onChange, defaultValue, label, required } = this.props;
        return (
            <div className="form-group">
                <label className="contact_label">{label} {required ? <span className="badge bg-danger">必須</span> : ""}</label>
                {options.map(option => {
                    const { id, optionName } = option;
                    return (
                        <div className="form-check" key={id}>
                            <input className="form-check-input" style={{ marginTop: "0.5em" }}
                                type="radio"
                                name={name}
                                id={id}
                                value={optionName}
                                onChange={onChange}
                                defaultChecked={defaultValue.optionName === optionName} />
                            <label className="form-check-label" htmlFor={id}>
                                {optionName}
                            </label>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default Radio;